import { render, staticRenderFns } from "./PageModelHub.vue?vue&type=template&id=140c2640&"
import script from "./PageModelHub.vue?vue&type=script&lang=js&"
export * from "./PageModelHub.vue?vue&type=script&lang=js&"
import style0 from "./PageModelHub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports